(function () {
    'use strict';

    angular.module('swif.interventions')
    .config(router)
    .controller('InterventionsController', InterventionsController)
    .controller('InterventionsTableController', InterventionsTableController)
    .controller('InterventionController', InterventionController)
    .controller('InterventionDetailsModalController', InterventionDetailsModalController)
    .component('interventionTask', {
        transclude: true,
        templateUrl: 'partials/openstc/intervention_task_component.html',
        controller: InterventionTaskComponent,
        bindings: {
            ngModel: "=",
            intervention: "=",
            state: "="
        }
    });

    function router($routeProvider, swifInterventionsConstant) {
        'ngInject';
        $routeProvider.when(swifInterventionsConstant.intervention.routes.explorer_view, {
            templateUrl: 'partials/openstc/interventions_explorer_view.html',
            controller: 'InterventionsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    return service.intervention.resolveData();
                }]
            }
        });
        $routeProvider.when(swifInterventionsConstant.intervention.routes.table_view, {
            templateUrl: 'partials/openstc/interventions_table_view.html',
            controller: 'InterventionsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    return service.intervention.resolveData();
                }]
            }
        });
        $routeProvider.when('/interventions/interventions/stats_view', {
            templateUrl: 'partials/openstc/interventions_stats_view.html',
            controller: 'InterventionsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    return service.intervention.resolveData();
                }]
            }
        });
    }

    function InterventionsController ($scope, $location, swif, openstc, data) {
        'ngInject';
        console.log('init InterventionsController');
        swif.message.addOnErrorHandler($scope);
        $scope.debug = $location.search().debug;
        $scope.modules = swif.module.modules;
        $scope.loading = {tasks: {}};
        $scope.cart = swif.cart;

        $scope.interventions = data.interventions;
        $scope.data = data;

        $scope.getProgressBarType = getProgressBarType;
        $scope.getTaskProgressBarType = getTaskProgressBarType;
        $scope.attachmentsAction = swif.action.getActionById('intervention', 'meta', 'attachments');

        $scope.preModal = openstcInterventionPreModal;
        $scope.preValidate = openstc.intervention.preValidate;

        $scope.callback = function (error, data) {
            openstc.intervention.callback(error, data);
        };
        $scope.callbackTask = openstc.intervention.callbackTask;
        $scope.preValidateTask = openstc.task.preValidate;
        $scope.preModalTask = openstc.intervention.preModalTask;
        $scope.toggleCurrentIntervention = toggleCurrentIntervention;
        $scope.displayTaskPanel = displayTaskPanel;
        $scope.setCurrentIntervention = setCurrentIntervention;
        $scope.displayInterventionPanel = displayInterventionPanel;
        $scope.closeInterventionPanel = closeInterventionPanel;
        $scope.closeTaskInfo = closeTaskInfo;

        $scope.$watch('interventions.currentItem', watchCurrentItem);
        $scope.$watch('interventions.currentItem', watchCurrentItemTasks, true);

        function openstcInterventionPreModal(data) {
            /**
             * Quick and (really) dirty fix for ticket #2671
             * scope issue when multiple subforms in intervention form
             *
             * This ugly workaround simulate a click outside of the list,
             * because everything works great but the close
             *
             * Two setTimeout in a row...
             *
             * Should be refact in the future.
             *
             * Sorry for that, please don't git blame me
             */
            setTimeout(() => { // let's open the modal window
                jQuery('.modal-content').on('click','.ui-select-choices-row-inner', () => {
                    setTimeout(() => {
                        jQuery('.modal-content')[0].click();
                    }, 100);
                });
            }, 1000);
            swif.collections.getCollection('interventions').preModal(data);
            return openstc.intervention.preModal(data);
        }

        function getProgressBarType(intervention) {
            /* if (intervention.overPourcent === 100) {
                return 'success';
            } else if (intervention.overPourcent < 100) {
                return 'info';
            } else if (intervention.overPourcent > 100) {
                return 'danger';
            } */
            if (intervention.state === 'finished') {
                return 'success';
            } else if (intervention.state === 'cancelled') {
                return 'danger';
            } else {
                return 'info';
            }
        }

        function getTaskProgressBarType (task) {
            if (task.state === 'done') {
                return 'success';
            } else if (task.state === 'cancelled') {
                return 'danger';
            } else {
                return 'info';
            }
        }

        function watchCurrentItem(newV) {
            if (newV) {
                swif.message.loading($scope.loading.tasks);
                openstc.intervention.createCollectionTasks(newV)
                .then(function (collection) {
                    $scope.tasks = collection;
                    swif.message.loading($scope.loading.tasks, 'ok');
                }, function () {
                    swif.message.loading($scope.loading.tasks, 'ko');
                });
            } else {
                delete $scope.tasks;
            }
        }

        function watchCurrentItemTasks(newItem, previousItem) {
            if (previousItem && newItem) {
                if (previousItem.id == newItem.id && newItem.tasks.length != previousItem.tasks.length) {
                    watchCurrentItem(newItem);
                }
            }
        }

        function setCurrentIntervention (intervention) {
            $scope.interventions.setCurrent(intervention);
        }

        function toggleCurrentIntervention (intervention) {
            if ($scope.interventions.currentItem) {
                if ($scope.interventions.currentItem.id === intervention.id) {
                    setCurrentIntervention();
                    return;
                }
            }
            setCurrentIntervention(intervention);
        }

        // //// COPY / PASTED from planning
        function displayTaskPanel (task) {
            if ($scope.display_task_id !== task.id) {
                $scope.display_task_id = task.id;
            } else {
                closeTaskInfo(task);
            }
        }

        function closeTaskInfo () {
            delete $scope.display_task_id;
        }

        function displayInterventionPanel (intervention) {
            if ($scope.display_inter_id !== intervention.id) {
                $scope.display_inter_id = intervention.id;
            } else {
                closeInterventionPanel(intervention);
            }
        }

        function closeInterventionPanel () {
            delete $scope.display_inter_id;
        }
    }

    function InterventionsTableController ($scope, $location, $uibModal, swif) {
        'ngInject';
        $scope.openCost = openCost;
        $scope.closeCost = function () {
            $scope.modalInstance.close();
        };
        if ($location.search().loadRequests) {
            $scope.$watchCollection('interventions.items', watchItems);
        }

        function openCost (item) {
            $scope.setCurrentIntervention(item);
            $scope.modalInstance = $uibModal.open({
                templateUrl: 'partials/openstc/intervention_cost_modal.html',
                size: 'lg',
                scope: $scope
            });
            $scope.showMore=false;
            $scope.showMoreModel = function () {
                $scope.showMore=!$scope.showMore;
            };
        }

        function watchItems (newV) {
            var ask_ids = [];
            var inter_ids = [];
            var ask_by_ids = {};
            var task_by_ids = {};
            if (newV) {
                _.forEach(newV, function (inter) {
                    inter_ids.push(inter.id);
                    if (inter.ask_id) {
                        ask_ids.push(inter.ask_id[0]);
                    }
                });
                if (!_.isEmpty(ask_ids)) {
                    var filter = {limit:0};
                    swif.data.addFilter(filter, 'id', 'in', ask_ids);
                    swif.data.searchRead('intervention_request', filter)
                    .then(function (data) {
                        _.forEach(data.records, function (request) {
                            ask_by_ids[request.id] = request;
                        });
                        _.forEach(newV, function (inter) {
                            if (inter.ask_id) {
                                inter._ask_id = ask_by_ids[inter.ask_id[0]];
                            }
                        });
                    });
                    var tfilter = {limit:0};
                    if (inter_ids.length > 0) {
                        swif.data.addFilter(tfilter, 'project_id', 'in', inter_ids);
                    } else {
                        // TODO: fix collection resolving when we search in empty project list
                        swif.data.addFilter(tfilter, 'project_id', 'in', ['--noValue--']);
                    }
                    swif.data.searchRead('task', tfilter)
                    .then(function (data) {
                        _.forEach(data.records, function (task) {
                            task_by_ids[task.id] = task;
                        });
                        _.forEach(newV, function (inter) {
                            if (inter.tasks) {
                                _.forEach(inter.tasks, function (id) {
                                    if (!inter._tasks) {
                                        inter._tasks = [];
                                    }
                                    inter._tasks.push(task_by_ids[id]);
                                });
                            }
                            //add _.tasks_first && _.tasks_last
                            inter._tasks_first = _.min(inter._tasks, function (task) {
                                if (task.date_start) {
                                    return swif.date.getMomentDatetime(task.date_start).unix();
                                }
                            });
                            inter._tasks_last = _.min(inter._tasks, function (task) {
                                if (task.date_end) {
                                    return swif.date.getMomentDatetime(task.date_end).unix();
                                }
                            });
                        });
                    });
                }
            }
        }
    }


    function InterventionController($scope, openstc, swif, $element, swifOpenbaseService, swifOpenbaseCompanyService, swifOpenbaseSiteService, gettextCatalog) {
        'ngInject';
        console.log('init InterventionController');
        swif.message.addOnErrorHandler($scope);
        var $ctrl = this;
        $ctrl.model = $scope.model;
        $scope.fullTasks = $scope.model.fullTasks;
        $scope.translate = {
            noNote: gettextCatalog.getString("Aucune note n'a été laissée au demandeur")
        };
        $scope.tasksToDuplicate = $scope.model.tasksToDuplicate;
        $ctrl.actionId = $scope.action.id;
        $ctrl.model.loading = {tasks: {}};
        $ctrl.model._type = 'intervention';
        $ctrl.model.create_task = $scope.model.create_task || false;
        $ctrl.model._tasks = $scope.model._tasks || {};
        $ctrl.state = {};
        $ctrl.useATemplate = false;
        $ctrl.hasTemplates = false;
        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $ctrl.state.advanced_mode = company.validate_request_window_advanced_mode;
            $ctrl.state.taskNotify = company.task_notify;
            $ctrl.state.taskNotifyDefaultValue = company.task_notify_default_value;
            $ctrl.projectTemplateEnabled = company.project_template_enable;
            $ctrl.requesterNoteEnable = company.request_note_enable;

            if ($ctrl.model._type==='intervention' && $ctrl.actionId==='validate') {
                // we display the 'ask validation window'
                $ctrl.state.task_advanced_mode = company.task_in_validate_request_window_advanced_mode;
                $ctrl.model.sync_state_from_tasks = company.intervention_window_synchronize_status;
            } else {
                if ($ctrl.actionId==='add') {
                    // we display the 'ask validation window'
                    $ctrl.state.task_advanced_mode = company.task_in_create_intervention_window_advanced_mode;
                }
            }
        });
        $ctrl.filters = {};
        openstc.intervention.updateFilters($ctrl.filters, $ctrl.model);
        $scope.$watch('$ctrl.model.intervention_assignement_id', watchCategory);
        $scope.$watch('$ctrl.model.create_task', watchCreateTask);
        $scope.$watch('$ctrl.model.service_id', watchServiceId);
        $scope.$watch('$ctrl.model.equipment_id', watchEquipmentId);
        $scope.$watch('$ctrl.model.custom_fields', watchCustomFieds);
        $scope.$watch('$ctrl.model._tasks', watchTaskCustomFieds);
        $scope.callbackTask = openstc.intervention.callbackTask;
        $scope.preValidateTask = openstc.task.preValidate;
        $scope.preModalTask = openstc.intervention.preModalTask;

        $ctrl.erase_name = function () {
            $ctrl.model.name = '';
        };

        $ctrl.expand = function (active) {
            if (active) {
                $element.parents('.modal-dialog:first').addClass('modal-large');

            } else {
                $element.parents('.modal-dialog:first').removeClass('modal-large');
            }
        };

        $ctrl._siteLoaded = false;
        $ctrl.loadInterventionSite = function() {
            if (!$ctrl._siteLoaded && swif.settings.app.modules.openstc_patrimoine && $ctrl.model.site1) {
                swifOpenbaseSiteService.getSiteAddressById($ctrl.model.site1[0]).then(site => {
                    swifOpenbaseSiteService.getSiteAddressFields().map(field => {
                        $ctrl.model.request[field] = site[field];
                    });
                    $ctrl._siteLoaded = true;
                });
            }
        };

        // Look for interventions templates
        swif.data.getContentRange('intervention_template').then(count => {
            $ctrl.hasTemplates = count > 0;
        });

        var task_default_hours;
        var task_temp_id = 0;
        var defaultTask = {
            name: $ctrl.model.name,
            service_id: angular.copy($ctrl.model.service_id),
            planned_hours: task_default_hours,
            _id: task_temp_id,
            _collapsed: false
        };

        $ctrl.addTask = function(task) {
            if (_.isUndefined(task)) {
                task = angular.copy(defaultTask);
            }
            task_temp_id += 1;
            task._id = task_temp_id;
            task.notify = $ctrl.state.taskNotifyDefaultValue;
            $ctrl.model._tasks.push(task);
        }

        $ctrl.removeTask = function(id) {
            var index = $ctrl.model._tasks.findIndex(t => t._id == id);
            var ret = $ctrl.model._tasks.splice(index, 1);
        }

        $ctrl.collapseAllTasks = function() {
            $ctrl.model._tasks.map(task => {
                task._collapsed = true;
            });
        }

        $ctrl.removeAllTasks = function() {
            $ctrl.model._tasks.splice(0, $ctrl.model._tasks.length);
        }

        $ctrl.moveTask = function(taskId, direction) {
            var tasks = $ctrl.model._tasks;
            var possibleDirections = ['up', 'down'];
            if (_.includes(possibleDirections, direction)) {
                var newIndex;
                var index = tasks.findIndex(t => t._id == taskId);
                if (direction === 'up') {
                    newIndex = index-1;
                } else if (direction === 'down') {
                    newIndex = index+1;
                }
                var taskToMove = _.remove(tasks, t => t._id == taskId);
                swifOpenbaseService.utils.insertItemInArray(tasks, newIndex, taskToMove[0]);
            }
        }

        $ctrl.addTasksFromRange = function(taskRange) {
            $ctrl._taskRange = undefined;
            $ctrl.isTaskRange = true;
            if (taskRange.id) {
                // Remove single task if it has no name
                if ($ctrl.model._tasks.length === 1 && $ctrl.model._tasks[0].name == undefined) {
                    $ctrl.model._tasks = [];
                }

                // Load tasks templates from task range
                addTasksTemplatesFromRelation('task_range_id', taskRange.id);
            }
        }

        if($ctrl.actionId === 'validate') {
            var oldNote = $ctrl.model.request.note_for_requester
            // Controls the interaction between note field and 'notify the requester' checkbox
            $ctrl.onNoteChange = function(newNote) {
                // Check the checkbox as soon as 1 character has been typed
                // In order to avoid automatic check when the user progressively remove chars,
                // we need to compare old and new notes
                if(oldNote !== $ctrl.model.request.note_for_requester) {
                    if(newNote && newNote.length >= 1 && (oldNote ? oldNote.length : 0) < $ctrl.model.request.note_for_requester.length) {
                        $ctrl.model.request.should_notify_requester = true;
                    }
                    // Update oldVal
                    oldNote = $ctrl.model.request.note_for_requester;
                }
                // If the user clear the textarea, uncheck
                if(!newNote) {
                    $ctrl.model.request.should_notify_requester = false;
                }
            }
        }

        var previousTemplate;
        $ctrl.onChangeTemplate = function(template) {
            /* === step 1 : fill fields ===  */
            var exclude_properties = ['id', '$$hashKey', '_type'];

            // Rename category_id key
            template.intervention_assignement_id = template.category_id
            delete template.category_id;

            _.forOwn(template, (value, key) => {
                if (!_.includes(exclude_properties, key)) {
                    if (_.isEmpty($ctrl.model[key]) || (previousTemplate && $ctrl.model[key] === previousTemplate[key])) {
                        $ctrl.model[key] = value;
                    }
                }
            });

            previousTemplate = template;

            /* === step 2 : fill tasks ===  */
            $ctrl.model._tasks = []; // Empty tasks for each template change

            // Add tasks from inter template
            addTasksTemplatesFromRelation('project_template_id', template.id);
        }

        function addTasksTemplatesFromRelation(columnName, id) {
            $ctrl.loadingTasksRange = true;
            var filter = {};
            swif.data.addFilter(filter, columnName, '=', id);
            swif.data.sortOn(filter, 'sequence', 'ASC');
            swif.collection.createOrUpdate(
                'intervention_tasks_templates',
                'task_template',
                filter
            ).then(collection => {
                collection.items.map(taskTemplate => {
                    // Manage multiple users template and old coexisting user format
                    var users = []
                    if (taskTemplate.user_ids.length > 0) {
                        users = taskTemplate.user_ids;
                    } else if (taskTemplate.user_id.length > 0) {
                        users = taskTemplate.user_id[0]
                    }
                    $ctrl.addTask({
                        name: taskTemplate.name,
                        category_id: taskTemplate.category_id,
                        user_id: users,
                        team_id: taskTemplate.team_id,
                        service_id: $ctrl.model.service_id,
                        partner_id: taskTemplate.partner_id,
                        planned_hours: taskTemplate.planned_hours,
                        description: taskTemplate.description,
                        isTaskRange: $ctrl.isTaskRange,
                        _collapsed: true
                    })
                });
                $ctrl.loadingTasksRange = false;
            });
        }

        function updateFilters() {
            $scope.filters = openstc.intervention.updateFilters($ctrl.filters, $ctrl.model);
        }

        function watchCategory(newV, oldV) {
            if ($ctrl.model === undefined) {
                return;
            }
            if (newV && newV!=oldV) {
                swif.data.get('intervention_category', newV[0])
                    .then(function (category) {
                        $ctrl.model.date_deadline = moment().add(category.delay, 'day').format('YYYY-MM-DD');
                    });
                if (_.isEmpty($ctrl.model.name)){
                    $ctrl.model.name = newV[1];
                }
                if (oldV && ($ctrl.model.name===oldV[1])){
                    // intervention name is updated if user didn't change the original category name
                    $ctrl.model.name = newV[1];
                }
            } else if (oldV && !newV) {
                if (oldV[1] === $ctrl.model.name) {
                    $ctrl.erase_name();
                }
            }
        }

        function watchCreateTask(newV) {
            if (newV === false) {
                delete $ctrl.model._tasks;
            } else {
                if (!$ctrl.model._tasks) {
                    $ctrl.model._tasks = [angular.copy(defaultTask)];
                    if (_.isUndefined(task_default_hours)) {
                        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                            task_default_hours = company.task_default_hours;
                            $ctrl.model._tasks[0].planned_hours = company.task_default_hours;
                            $ctrl.model._tasks[0].notify = company.task_notify_default_value;
                            $ctrl.taskRangeEnabled = company.task_range_enable;
                        });
                    }
                }
            }
        }
        function watchServiceId(newV, oldV) {
            //sync inter service_id with task service
            var m = $ctrl.model;
            var eq = angular.equals;
            if (m.id === undefined && m._tasks && m._tasks.length && !eq(newV,oldV)) {
                angular.forEach(m._tasks, (task) => {
                    if (!task.service_id) {
                        task.service_id = angular.copy(newV);
                    }
                    if (!eq(task.service_id, newV) && eq(task.service_id, oldV)) {
                        task.service_id = angular.copy(newV);
                    }
                })
            }
        }
        function watchEquipmentId(newV, oldV) {
            //sync inter equipment with task equipment
            var m = $ctrl.model;
            var eq = angular.equals;
            if (m.id === undefined && m._tasks && m._tasks.length && !eq(newV,oldV)) {
                angular.forEach(m._tasks, (task) => {
                    if (!task.equipment_id) {
                        task.equipment_id = angular.copy(newV);
                    }
                    if (!eq(task.equipment_id, newV) && eq(task.equipment_id, oldV)) {
                        task.equipment_id = angular.copy(newV);
                    }
                })
            }
            if (newV) {
                updateFilters();
            } else if (!angular.equals(newV, oldV)) {
                updateFilters();
            }
        }
        function watchCustomFieds (newV) {
            if (newV) {
                let filter = {};
                filter.fields = ['id', 'name'];
                swif.data.setLimit(filter, 1);
                swif.data.addExtraFilter(filter, 'service', 'name', '=', newV);
                swif.data.searchRead('department', filter).then(function(data) {
                    if (data.records && data.records.length > 0) {
                        const service = data.records[0];
                        $scope.$parent.$parent.model.service_id = [service.id, service.name];
                    }
                });
            }
        }
        function watchTaskCustomFieds (newV) {
            if (newV) {
                newV.forEach((task) => {
                    let filter = {};
                    filter.fields = ['id', 'name'];
                    swif.data.setLimit(filter, 1);
                    swif.data.addExtraFilter(filter, 'service', 'name', '=', task.customField);
                    swif.data.searchRead('department', filter).then(function(data) {
                        if (data.records && data.records.length > 0) {
                            const service = data.records[0];
                            task.service_id = [service.id, service.name];
                        }
                    });
                })
            }
        }
    }

    function InterventionTaskComponent($scope, openstc, swif) {
        'ngInject';
        var $ctrl = this;
        $ctrl.model = $ctrl.ngModel;

        this.$onInit = function() {
            $scope.siteOnTaskFeature = swif.settings.app.features.siteOnTask;
            $ctrl.filters = {};
            if (_.isUndefined($ctrl.model)) {
                $ctrl.model = {};
            }
        }

        $ctrl.erase_name = function () {
            $ctrl.model.name = '';
        };

        $scope.$watchGroup([
            '$ctrl.model.user_id',
            '$ctrl.state.advanced_mode',
            '$ctrl.model.team_id',
            '$ctrl.model.partner_id',
            '$ctrl.model.service_id'
        ], watchTaskToUpdateService);
        $scope.$watchGroup([
            '$ctrl.model.date_start',
            '$ctrl.model.planned_hours',
            '$ctrl.model.report_hours'
        ], watchToUpdatDateEndFromStartPlusDuration);
        $scope.$watch('$ctrl.model.service_id', watchTaskServiceId);
        $scope.$watch('$ctrl.model.category_id', watchTaskCategoryId);

        var updateTaskFilters = function () {
            if ($ctrl.model) {
                $ctrl.filters.task = openstc.task.getFilters(
                    $ctrl.model, $ctrl.intervention, $ctrl.state.task_advanced_mode
                );
            }
        };

        var updatDateEndFromStartPlusDuration = function () {
            if ($ctrl.model) {
                openstc.task.syncDateEnd($ctrl.model);
            }
        };

        function watchTaskToUpdateService(newV) {
            updateTaskFilters();
            if (newV[0] && $ctrl.model) {
                openstc.task.updateServiceFromUser($ctrl.model, newV[0][0]);
            }
        }
        function watchToUpdatDateEndFromStartPlusDuration() {
            if ($ctrl.model) {
                updatDateEndFromStartPlusDuration();
            }
        }
        function watchTaskServiceId (newV) {
            if (!newV && $ctrl.model.service_id && $ctrl.model) {
                $ctrl.model.service_id = angular.copy($ctrl.intervention.service_id);
            }
        }
        function watchTaskCategoryId (newV, oldV) {
            var task = $ctrl.model;
            if (task) {
                var newVal = newV ? newV[1] : '';
                var oldVal = oldV ? oldV[1] : '';
                var newString = task.name;
                if(!task.name && newVal) {
                    newString = newVal;
                }else if(!angular.equals(newVal, oldVal) && oldVal === task.name) {
                    newString = newVal;
                }
                task.name = newString;
            }
        }
    }

    function InterventionDetailsModalController($scope, $uibModalInstance, modalParams, swif, swifRouteService, swifCartoLeafletService, swifOpenbaseKeysService) {
        'ngInject';

        $scope.model = modalParams.model;
        const user = swif.user.getAuthenticatedUserData();
        const isManager = (_.includes(user.access_rights, 'MANA') || _.includes(user.access_rights, 'ELU'));
        $scope.extra = '';
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        const cartoService = swifCartoLeafletService;
        $scope.setExtra = function(view) {
            if (view === 'map') {
                swifRouteService.check({resources: ['leaflet']}).then(function () {
                    $scope.extra = view;
                });
            } else {
                $scope.extra = view;
            }
        }

        // Watch model attachments loading
        $scope.$watch('model._attachments', function (newV, oldV) {
            $scope.attachments = newV;
        });
        $scope.$watch('model._attachments_img', function (newV, oldV) {
            $scope.images = newV;
        });

        // Get keys
        if (isManager) {
            let keysFilter = {};
            swif.data.addFilter(keysFilter, 'site_ids', 'in', [$scope.model.site1[0]])
            swif.data.get('key', undefined, keysFilter).then(function (keys) {
                $scope.keys = keys;
            });
        }

        // Init map
        $scope.onMapInitialized = function (map) {
            $scope.map = map;
            if ($scope.model.osm_zoom) {
                $scope.map.setZoom($scope.model.osm_zoom);
            }
            if ($scope.model.geo_point) {
                // Display site polygon, parents polygons and inter geo_point
                cartoService.getParentSiteWithPolygon($scope.model.site.id).then(parentSites => {
                    // Add current site to his parents
                    var sites = parentSites.concat([$scope.model.site]);

                    var polygons = cartoService.setChildAndParentsPolygons(sites);
                    var layer = L.featureGroup(polygons);
                    layer.addTo($scope.map);

                    let marker = cartoService.getMarkerFromPoint($scope.model.geo_point);
                    if (marker) {
                        marker.addTo(layer);
                        $scope.map.setView(marker.getLatLng());
                    }
                    if (!$scope.model.geo_point && !_.isEmpty(polygons)) {
                        // We want to center the map to the current site (the last item)
                        var bounds = _.last(polygons).getBounds();
                        $scope.map.fitBounds(bounds);
                    }
                });
            }
        };

        // Get site data
        $scope.siteFilter = {fields: ['name', 'type_id', 'site_parent_id', 'surface', 'code', 'lat', 'long', 'street', 'street2', 'zip', 'city',
        'geo_polygon']};
        swif.data.get('site', $scope.model.site1[0], $scope.siteFilter).then(function(data){
            $scope.model.site = data;

            // Init extra view
            if ($scope.extra === '' && $scope.model.geo_point) {
                $scope.setExtra('map');
            }
        });
    }

})();
